// extracted by mini-css-extract-plugin
export default {"ribbon":"styles__ribbon--VUo9l","icon":"styles__icon--ngz39"};